'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _culture = require('./culture.model');

var _culture2 = _interopRequireDefault(_culture);

var _nature = require('./nature.model');

var _nature2 = _interopRequireDefault(_nature);

var _outdoor = require('./outdoor.model');

var _outdoor2 = _interopRequireDefault(_outdoor);

var _service = require('./service.model');

var _service2 = _interopRequireDefault(_service);

var _typicalProduct = require('./typicalProduct.model');

var _typicalProduct2 = _interopRequireDefault(_typicalProduct);

var _itinerary = require('./itinerary.model');

var _itinerary2 = _interopRequireDefault(_itinerary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Model = function Model() {
  'ngInject';

  return {
    getModelsConstant: getModelsConstant,
    getByEnum: getByEnum,
    getModel: getModel,
    getNatureStructure: getNatureStructure,
    getOutdoorStructure: getOutdoorStructure,
    getCultureStructure: getCultureStructure,
    getServiceStructure: getServiceStructure,
    getTypicalProductStructure: getTypicalProductStructure,
    getItineraryStructure: getItineraryStructure

    /**
     *Enum: usato per caricare le immagini su s3
     * Name: usato per l'ng-model (in nome del campo tornato dal server)
     */
  };function getModelsConstant() {
    return {
      CULTURE: { enum: 'CULTURE', name: 'culture' },
      ITINERARY: { enum: 'ITINERARY', name: 'itinerary' },
      INFORMATION: { enum: 'INFORMATION', name: 'information' },
      NATURE: { enum: 'NATURE', name: 'nature' },
      TYPICALPRODUCT: { enum: 'TYPICALPRODUCT', name: 'typicalProduct' },
      SERVICE: { enum: 'SERVICE', name: 'service' },
      OUTDOOR: { enum: 'OUTDOOR', name: 'outdoor' }
    };
  }

  function getByEnum(modelEnum) {
    var models = getModelsConstant();
    if (_.has(models, modelEnum)) {
      return _.get(models, modelEnum);
    }
    throw 'Unknown model type';
  }

  function getModel(serverResponce) {
    if (_.has(serverResponce, 'culture')) return getModelsConstant().CULTURE;else if (_.has(serverResponce, 'information')) {
      return getModelsConstant().INFORMATION;
    } else if (_.has(serverResponce, 'itinerary')) {
      return getModelsConstant().ITINERARY;
    } else if (_.has(serverResponce, 'nature')) {
      return getModelsConstant().NATURE;
    } else if (_.has(serverResponce, 'typicalProduct')) {
      return getModelsConstant().TYPICALPRODUCT;
    } else if (_.has(serverResponce, 'service')) {
      return getModelsConstant().SERVICE;
    } else if (_.has(serverResponce, 'outdoor')) {
      return getModelsConstant().OUTDOOR;
    } else {
      throw 'Unknown model type';
    }
  }

  function getCultureStructure() {
    return _culture2.default;
  }
  function getNatureStructure() {
    return _nature2.default;
  }
  function getOutdoorStructure() {
    return _outdoor2.default;
  }
  function getServiceStructure() {
    return _service2.default;
  }
  function getTypicalProductStructure() {
    return _typicalProduct2.default;
  }
  function getItineraryStructure() {
    return _itinerary2.default;
  }
};

exports.default = Model;


// WEBPACK FOOTER //
// ./client/app/common/factories/modelFactory/model.service.js